import { LoginService } from 'src/app/login/login.service';
import { PessoaService } from './../../pessoa.service';
import { Clube } from '../clube';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { SwalComponent } from '@toverux/ngx-sweetalert2';
import { Federacao } from '../../federacao/federacao';
import { SYSCONF_SIGLA } from 'src/app.api';
@Component({
	selector: 'app-clube-edit',
  	templateUrl: './clubeEdit.component.html',
  	styleUrls: ['./clubeEdit.component.scss']
})
export class ClubeEditComponent implements OnInit{
	@ViewChild('Swal') public swal:SwalComponent; 
	federacoes: Federacao[];
	public message:string = '';
	editForm: FormGroup;
	clube: Clube;
	clube_id:number;
	thumb:string = '';
	pessoa_id:number;
	enderecos:object = new Array();
	telefones:object = new Array();
	contasBancarias:object = new Array();
	sigla = SYSCONF_SIGLA;
	anexos: any;
	acesso = new Array();
	constructor(public loginService: LoginService,private pessoaService: PessoaService , private activatedRoute: ActivatedRoute ,private formBuilder: FormBuilder){
		this.editForm = this.formBuilder.group({
			id: this.formBuilder.control(0,[Validators.required]),
			dt_cadastro: this.formBuilder.control(''),
			dt_atualizacao: this.formBuilder.control(''),
			cnpj: this.formBuilder.control('',[Validators.required]),
			razao_social: this.formBuilder.control('',[Validators.required]),
			nome_completo: this.formBuilder.control('',[Validators.required]),
			email: this.formBuilder.control('',[Validators.required, Validators.email]),
			status: this.formBuilder.control('',[Validators.required]),
			federacao_id: this.formBuilder.control(''),
			sigla: this.formBuilder.control('',[Validators.required]),
			federado: this.formBuilder.control('',[Validators.required]),
			observacao: this.formBuilder.control(''),
			website: this.formBuilder.control(''),
		});	
		this.pessoaService.getOptions('pessoa/federacao')
        .subscribe( (success) => {
			this.federacoes = success.dados;
		},
		(error) => {
			// this.swal.text = error.error.message;
			// this.swal.type = "error";
			// this.swal.title = "Erro!";
			// this.swal.show();
		});
		this.clube_id = this.activatedRoute.snapshot.params['id'];
		this.pessoaService.getPessoaById('pessoa/clube',this.clube_id).subscribe(
			(clube) => {
			this.clube = clube.dados;
			this.pessoa_id = this.clube.pessoa_id;
			this.acesso = this.clube.acesso;
			if(this.clube.foto){
				this.thumb = this.clube.foto.thumb;
			}
			this.pessoaService.getPessoaById('pessoa',this.pessoa_id).subscribe(
				(success) =>{
					this.enderecos = success.dados.endereco;
					this.telefones = success.dados.telefone;
					this.contasBancarias = success.dados.conta_bancaria;
					this.anexos = success.dados.anexo;
				},
				(error) => {
					this.message = error.error.message;
				})
			
			this.editForm.patchValue({
				id: this.clube.id,
				dt_cadastro: this.clube.dt_cadastro_br,
				dt_atualizacao: this.clube.dt_atualizacao_br,
				cnpj: this.clube.cnpj,
				razao_social: this.clube.razao_social,
				nome_completo: this.clube.nome_completo,
				email: this.clube.email,
				status: this.clube.status,
				federacao_id: this.clube.federacao_id,
				sigla: this.clube.sigla,
				federado: this.clube.federado == 'S' ? 'S' : 'N',
				website: this.clube.website,
				observacao: this.clube.observacao
			});
			
		},
		(error) => {
			this.message = error.error.message;
		})
	}
	ngOnInit(){
		let t = JSON.parse(localStorage.getItem('CONFLogin'));
		if(!t.permissao.pessoa_clube.includes("EDITAR"))
			this.message = 'Você não possui permissão para executar esta ação'
	}	
}